import ProgramInfo from '../views/interestsection/programinfo.vue';
import ProgramActivities from '../views/interestsection/programactivities.vue';
import ProgramKnowledge from '../views/interestsection/programaknowledge.vue';
import ProgramSkills from '../views/interestsection/programskills.vue';
import ProgramEssentialSkills from '../views/interestsection/programessentialskills.vue';
import ProgramDone from '../views/interestsection/programdone.vue';
import ProgramCriteriaSelection from '../views/interestsection/programcriteriaselection.vue';

export default [{
  path: '/',
  component: ProgramCriteriaSelection,
  // meta: {
  //   requiredRole: process.env.VUE_APP_ROLE_ADMIN,
  // },
  children: [
    {
        path: '',
        name: 'ProgramInfo',
        component: ProgramInfo,
        meta: {
        type: 'small'
        }
    },
    {
        path: '2',
        name: 'ProgramActivities',
        component: ProgramActivities,
        meta: {
        type: 'split'
        }
    },
    {
        path: '3',
        name: 'ProgramKnowledge',
        component: ProgramKnowledge,
        meta: {
        type: 'small'
        }
    },
    {
        path: '4',
        name: 'ProgramSkills',
        component: ProgramSkills,
        meta: {
        type: 'small'
        }
    },
    {
        path: '5',
        name: 'ProgramEssentialSkills',
        component: ProgramEssentialSkills,
        meta: {
        type: 'small'
        }
    },
    {
        path: 'thankyou',
        name: 'ProgramDone',
        component: ProgramDone,
        meta: {
        type: 'small'
        }
    }
]
}];
